import {
    ButtonPrimary,
    Divider,
    IconChevronLeftRegular,
    IconLockClosedRegular,
    NavigationBar,
    skinVars,
    Text2,
    Text3,
    TextField,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { getRoleLine } from '../../../../utils/dataTransformation/productConsumption';
import { useState } from 'react';
import './index.scss';
import { activateSIM, getSIMSInfo } from '../../../../services/ConfigureLineService';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { useQuery } from '@tanstack/react-query';
import { useConfigureLineContext } from '../../../../utils/store/context/configure-line-context/ConfigureLineContext';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';

const ActivateSim = () => {
    const navigate = useNavigate();
    const { lineActive, isConvergent } = useConfigureLineContext();
    const [iccNumber, setIccNumber] = useState('');

    const consumptions = JSON.stringify(window.localStorage.getItem('storages'));
    const { data: simInfo } = useQuery(['sims-info'], () => (lineActive ? getSIMSInfo(lineActive) : null), {
        enabled: !!lineActive,
    });

    const navigationBackHandler = () => navigate(`/configure-line`);

    const activationHandler = async () => {
        try {
            await activateSIM(simInfo?.number!, iccNumber);

            navigate('/configure-line/sim/sim-activation-feedback');
        } catch (error) {
            console.error(error);
        }
    };

    const changeIccHandler = (value: string) => {
        const tempValue = value.replaceAll(' ', '');
        if (/[^0-9]/.test(tempValue)) return;
        setIccNumber(tempValue);
    };

    return (
        <div className='activation-sim'>
            <div className='activation-sim__header'>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='activation-sim__header-navigationBar'>
                            <NavigationBar
                                withBorder={false}
                                onBack={navigationBackHandler}
                                title={t('simActivation')}
                            />
                        </div>
                        <div
                            className='activation-sim__header-return'
                            onClick={() => {
                                navigate(`/configure-line`);
                            }}
                        >
                            <div className='activation-sim__header-return-icon'>
                                <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textPrimary}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>
                    </>
                )}

                <div className='activation-sim__breadcrumbs'>
                    <BreadCrumbsWrapper
                        title={t('simActivation')}
                        breadcrumbs={
                            !isConvergent
                                ? [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                                : [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: getRoleLine(JSON.parse(consumptions), simInfo?.productPsId!),
                                          url: `/mobile?productPsId=${simInfo?.productPsId}`,
                                      },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                        }
                    />
                </div>
            </div>

            <Divider />

            <div className='activation-sim__body'>
                <Text3 regular>{t('activateSimPhysicalTitle')}</Text3>
                <TextField
                    fullWidth={true}
                    label={t('iccNumberInputLabel')}
                    name='icc-number-input'
                    autoFocus
                    helperText={t('iccNumberInputHelperText')}
                    maxLength={5}
                    onChange={(e) => changeIccHandler(e.target.value)}
                    value={iccNumber.length === 4 ? iccNumber.replace(/(\d{3})(\d)/, '$1 $2') : iccNumber}
                />
            </div>

            <div className='activation-sim__bottom'>
                <ButtonPrimary
                    StartIcon={IconLockClosedRegular}
                    role='onPress'
                    onPress={activationHandler}
                    disabled={iccNumber.length < 4}
                >
                    {t('enableShareBtnActivate')}
                </ButtonPrimary>
            </div>
        </div>
    );
};

export default ActivateSim;
